import { useBrainStore } from '@/state/brainStore';
import { useSimulationStore } from '@/state/simulationStore';
import { currentActorId } from '@/domain/actor';
import { gapKeyFor, sweeperOutcomeId } from '@/domain/sweeperOutcomes';
import type { SweeperOutcome, SweeperOutcomeKind } from '@/domain/types';

/**
 * Record what a Sweeper's call to a gap candidate came to (B7, 8xat D08-16 /
 * 75nh D08-26). One row per gap and client; the persistence bridge PUTs it, and
 * the server checks `by` against the login token (validators/sweeperOutcomes),
 * reverting the store and saying why if it refuses. "Now" is the sim clock.
 * Returns the outcome, or undefined when nobody is signed in or the artist is
 * unknown.
 */
export function recordSweeperOutcome(input: {
  customerId: string;
  artistId: string;
  dayIso: string;
  outcome: SweeperOutcomeKind;
  note?: string;
}): SweeperOutcome | undefined {
  const brain = useBrainStore.getState();
  const artist = brain.artists[input.artistId];
  const by = currentActorId();
  if (!artist || !by) return undefined;
  const gapKey = gapKeyFor(input.artistId, input.dayIso);
  const note = input.note?.trim();
  const outcome: SweeperOutcome = {
    id: sweeperOutcomeId(gapKey, input.customerId),
    customerId: input.customerId,
    artistId: input.artistId,
    studioId: artist.studioId,
    gapKey,
    outcome: input.outcome,
    by,
    at: useSimulationStore.getState().clockIso,
    ...(note ? { note } : {}),
  };
  brain.upsertSweeperOutcome(outcome);
  return outcome;
}
